import api from './api';

export interface MissionValue {
  _id: string;
  name: string;
  valueType: 'Mission' | 'Objective' | 'Goal' | 'Metric' | 'Outcome' | 'Other';
  description?: string;
  stakeholder?: string;
  priority: 'Critical' | 'High' | 'Medium' | 'Low';
  order: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateMissionValue {
  name: string;
  valueType: 'Mission' | 'Objective' | 'Goal' | 'Metric' | 'Outcome' | 'Other';
  description?: string;
  stakeholder?: string;
  priority?: 'Critical' | 'High' | 'Medium' | 'Low';
  order?: number;
  isActive?: boolean;
}

export interface UpdateMissionValue extends Partial<CreateMissionValue> {}

const base = '/mission-values';

const missionValuesService = {
  async list(q?: string): Promise<MissionValue[]> {
    const res = await api.get(`${base}`, { params: q ? { q } : undefined });
    return res.data.data as MissionValue[];
  },
  async create(payload: CreateMissionValue): Promise<MissionValue> {
    const res = await api.post(`${base}`, payload);
    return res.data.data as MissionValue;
  },
  async update(id: string, payload: UpdateMissionValue): Promise<MissionValue> {
    const res = await api.put(`${base}/${id}`, payload);
    return res.data.data as MissionValue;
  },
  async remove(id: string): Promise<void> {
    await api.delete(`${base}/${id}`);
  },
};

export default missionValuesService;
